{
  "version": 1,
  "asset_id": "a3d76423-6a90-4c4b-8ffa-99c5531d5dcb",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/a3d76423-6a90-4c4b-8ffa-99c5531d5dcb/suspension-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/a3d76423-6a90-4c4b-8ffa-99c5531d5dcb/suspension-hero.webp",
  "original_filename": "suspension-hero.webp",
  "size": 89436,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:29Z"
}
